import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Cart.svg'

export const IconCart = IconSVG as IconComponent
